<mat-sidenav-container
  fullscreen
  [@.disabled]="(mini$ | async) === false"
  autosize>
  <!--
    Main sidenav. We change its zIndex because when dynamic sidenav is opened, backdrop
    would not cover main sidenav(which is in closed state). User can't click on main sidenav
    items while dynamic sidenav is opened.
  -->

  <mat-sidenav
    #sidenav="matSidenav"
    [mode]="(mobile$ | async) ? 'over' : 'side'"
    [opened]="
      (mobile$ | async) === false && (isLargeScreen$ | async)
        ? leftSidenavExpanded()
        : false
    "
    [autoFocus]="false"
    [class.mat-drawer-mini]="mini$ | async"
    [@size]="
      (isUploadRoute$ | async) ? 'hidden' : leftSidenavExpanded() ? '1' : '0'
    "
    [@.disabled]="isUploadRoute$ | async"
    [style.width.px]="
      (isUploadRoute$ | async)
        ? 0
        : leftSidenavExpanded()
          ? SIDENAV_W.expanded
          : SIDENAV_W.mini
    "
    qtUiTour
    qtUiTourDescription="FTR_TOUR_NAV_MENU"
    qtUiTourRoutePath="/cal"
    qtUiTourPosition="right"
    [qtUiTourElementFixed]="true">
    <qt-sidenav
      [mini]="mini$ | async"
      [expanded]="leftSidenavExpanded()"
      (sidenavToggle)="toggleLeftSidenav()"></qt-sidenav>
  </mat-sidenav>

  <mat-sidenav
    #rightSidenav="matSidenav"
    class="right-sidenav"
    mode="side"
    position="end"
    [opened]="false"
    [autoFocus]="false"
    fixedInViewport="true"
    [fixedTopGap]="0"
    [style.width.px]="rightPanelOpened() ? rightSidenavWidth() : 0">
    <qt-right-sidenav
      [mini]="mini$ | async"
      (closeSidenav)="toggleRightSidenav()"
      (widthChange)="onRightSidenavWidthChange($event)"
      (activeTabChange)="onRightSidenavTabChange($event)"
      (chatAvailabilityChange)="onChatAvailabilityChange($event)" />
  </mat-sidenav>

  <mat-sidenav-content
    class="layout__wrapper"
    [style.--layout-left-margin]="
      (isUploadRoute$ | async)
        ? '0px'
        : (mobile$ | async)
          ? '0px'
          : leftSidenavExpanded()
            ? '220px'
            : '70px'
    "
    [style.margin-right.px]="rightPanelOpened() ? rightSidenavWidth() : 0">
    @let impersonatedEmail = impersonatedEmail$ | async;
    <qt-toolbar
      class="layout__toolbar"
      (toggleToolbar)="toggleLeftSidenav()"
      (toggleRightPanel)="toggleRightSidenav()"
      (openAiChat)="toggleRightSidenavTab('chat')"
      (openTasks)="toggleRightSidenavTab('tasks')"
      (addNote)="addNoteFromToolbar()"
      (addContact)="addContactFromToolbar()"
      (addDeal)="addDealFromToolbar()"
      [mini]="mini$ | async"
      [isLargeScreen]="isLargeScreen$ | async"
      [rightPanelOpened]="rightPanelOpened()"
      [rightPanelActiveTab]="rightSidenavActiveTab"
      [showAiChat]="canShowAiChat"
      [showAddDeal]="canAddDeal"></qt-toolbar>
    @if (isImpersonating()) {
      <div class="layout__impersonation-banner-row">
        <section
          class="layout__impersonation-banner"
          role="status"
          aria-live="polite">
          <div class="layout__impersonation-banner-text">
            {{ 'GNR_ADMIN_MODE_SIGNED_IN_OF' | translate }}
            @if (impersonatedEmail) {
              ({{ impersonatedEmail }}).
            } @else {
              {{ 'GNR_THE_SELECTED_USER' | translate }}.
            }
            {{ 'GNR_ACTIONS_WILL_BE_LOGGED' | translate }}
          </div>
          <button
            type="button"
            mat-flat-button
            class="layout__impersonation-banner-action"
            (click)="endImpersonationSession()">
            {{ 'GNR_END_SESSION' | translate }}
          </button>
        </section>
      </div>
    }
    <qt-network-error [error]="networkError$ | async"></qt-network-error>
    <main
      class="layout__content"
      [ngStyle]="{
        'background-color': router.url === '/' ? '#E7EFFD' : '#fff',
      }"
      #contentDiv>
      <div #childDiv>
        <router-outlet></router-outlet>
      </div>
      @if (uiTourService.showButtonObservable | async) {
        <span
          (click)="uiTourService.openTour(tutorialTemplateRef)"
          class="tour-button"
          [matTooltip]="'FTR_TOUR_CLICK_OPEN' | translate">
          <mat-icon aria-label="Open tutorial" class="tour-button__icon"
            >help_outline</mat-icon
          >
        </span>
      }
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- MOVE TO COMPONENT -->
<ng-template #tutorialTemplateRef>
  <div id="tour-overlay"></div>
  <mat-card class="ui-guide-step">
    <div fxLayout fxLayoutAlign="end">
      <button mat-icon-button (click)="finishUiTour()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-card-content class="mb-0 pt-1" fxLayout fxLayoutAlign="start center">
      <div id="ui-guide-step__content"></div>
      <img id="ui-guide-step__content-picture" />
    </mat-card-content>
    <mat-card-actions fxLayout fxLayoutAlign="end center">
      <div fxFlex class="ui-guide-step__counter">
        {{ actualStepNumber }} / {{ maxStepNumber }}
      </div>
      @if (actualStepNumber !== 1) {
        <button mat-button (click)="back()">
          <mat-icon>keyboard_arrow_left</mat-icon>
          {{ 'CMD_BACK' | translate }}
        </button>
      }
      @if (actualStepNumber === maxStepNumber) {
        <button mat-button (click)="finishUiTour()">
          {{ 'CMD_FINISH' | translate }}
          <mat-icon>done_all</mat-icon>
        </button>
      } @else {
        <button mat-button (click)="next()">
          {{ 'CMD_NEXT' | translate }}
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      }
    </mat-card-actions>
  </mat-card>
</ng-template>

<!-- <ng-container *ngIf="isUiTourOpen">

</ng-container> -->
